module.exports = __webpack_public_path__ + "static/media/elvanto-icon-white.ba11d83d.svg";